export default __webpack_public_path__ + "static/media/completed.8c2a0ed0.svg";